module.exports = __webpack_public_path__ + "img/base_hiver_raquettes.6905045d.svg";